export default __webpack_public_path__ + "static/media/locations-header.645c6e63.png";